module.exports = __webpack_public_path__ + "c70195b6db5693f8825135e3040d53a1.svg";